export class UpdateAwsSourceAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateAwsSourceAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
